import { useConsent } from './useConsent';
import { useEffect } from 'react';
import { initHotjar } from './hotjar';
import mixpanel from 'mixpanel-browser';
import { captureException } from '@sentry/react';
import { initMixpanel } from './mixpanel';

/** Component to gate analytics tracking on user cookie consent on initial site load. `<ConsentProvider>` attaches an event listener for consent changes via CookieYes banner */
export const ConsentGate = () => {
  const { consent } = useConsent();
  useEffect(() => {
    if (!consent.initialized) return; // wait for user to interact with banner
    if (consent.analytics) {
      const mixPanelInitialized = initMixpanel();
      if (mixPanelInitialized) {
        mixpanel.opt_in_tracking();
      }
      initHotjar();
    } else {
      try {
        // just sent to sentry, if mixpanel was never initialized this is just noise. potentially remove
        mixpanel.opt_out_tracking();
        // no-op for hotjar as they don't provide an opt out.
      } catch (e) {
        captureException(e);
      }
    }
  }, [consent.analytics, consent.initialized]);
  return null;
};
